import { SVGProps } from "react";

const IncreaseMarketIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="rgba(255,255,255,0)" d="M0 0h16v16H0z" data-name="Rectangle 484" />
      <path
        fill="currentColor"
        d="M8.232 5.471a.328.328 0 0 0-.465 0L4.41 8.829a.328.328 0 0 0 0 .465l.618.618a.328.328 0 0 0 .465 0L8 7.404l2.507 2.507a.328.328 0 0 0 .465 0l.618-.618a.328.328 0 0 0 0-.465ZM14.781 8A6.78 6.78 0 0 0 8 1.219 6.78 6.78 0 0 0 1.219 8 6.78 6.78 0 0 0 8 14.781 6.78 6.78 0 0 0 14.781 8Zm-1.312 0A5.467 5.467 0 0 1 8 13.469 5.467 5.467 0 0 1 2.531 8 5.467 5.467 0 0 1 8 2.531 5.467 5.467 0 0 1 13.469 8Z"
        data-name="Path 4617"
      />
    </svg>
  );
};

export default IncreaseMarketIcon;
